import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { StoreProvider } from './store';
import { Navigation } from './components/navigation';
import { LandingPage } from './pages/LandingPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { CreateEventPage } from './pages/CreateEventPage';
import { JoinPage } from './pages/JoinPage';
import { DashboardPage } from './pages/DashboardPage';
import { BetPage } from './pages/BetPage';
import { AdminPage } from './pages/AdminPage';
import { AddFightPage } from './pages/AddFightPage';
import { EnterResultPage } from './pages/EnterResultPage';
import { EditFightPage } from './pages/EditFightPage';
import { ScreenCastPage } from './pages/ScreenCastPage';
import { PropsBetPage } from './pages/PropsBetPage';
import { ParticipantReviewPage } from './pages/ParticipantReviewPage';
import { UserAccountPage } from './pages/UserAccountPage';
import { MyGamesPage } from './pages/MyGamesPage';
import { GlobalLeaderboardPage } from './pages/GlobalLeaderboardPage';
import { EventLeaderboardPage } from './pages/EventLeaderboardPage';
import { UserBetsPage } from './pages/UserBetsPage';
import { SelectTemplatePage } from './pages/SelectTemplatePage';
import { CreateTemplatePage } from './pages/CreateTemplatePage';
import { TemplatesPage } from './pages/TemplatesPage';
import { UserEventsPage } from './pages/UserEventsPage';

/**
 * App Component
 * 
 * AUTHENTICATION: Firebase Auth
 * - Firebase Auth for user authentication
 * - Firebase Firestore stores event/bet data
 */
function App() {
  console.log('📱 App component rendering...');
  
  return (
    <StoreProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-primary-bg">
          <Navigation />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/games" element={<MyGamesPage />} />
            <Route path="/account" element={<UserAccountPage />} />
            <Route path="/leaderboard" element={<GlobalLeaderboardPage />} />
            <Route path="/create" element={<CreateEventPage />} />
            <Route path="/create/select-template" element={<SelectTemplatePage />} />
            <Route path="/join/:eventId" element={<JoinPage />} />
            <Route path="/event/:eventId" element={<DashboardPage />} />
            <Route path="/event/:eventId/bet/:fightId" element={<BetPage />} />
            <Route path="/event/:eventId/props/:fightId" element={<PropsBetPage />} />
            <Route path="/admin/:eventId" element={<AdminPage />} />
            <Route path="/admin/:eventId/fights/new" element={<AddFightPage />} />
            <Route path="/admin/:eventId/fights/:fightId" element={<EditFightPage />} />
            <Route path="/admin/:eventId/fights/:fightId/result" element={<EnterResultPage />} />
            <Route path="/admin/:eventId/participants/:participantId" element={<ParticipantReviewPage />} />
            <Route path="/screencast/:eventId" element={<ScreenCastPage />} />
            <Route path="/leaderboard/:eventId" element={<EventLeaderboardPage />} />
            <Route path="/leaderboard/:eventId/user/:participantId" element={<UserBetsPage />} />
            {/* Ultra Admin Routes */}
            <Route path="/ultra-admin/templates" element={<TemplatesPage />} />
            <Route path="/ultra-admin/templates/create" element={<CreateTemplatePage />} />
            <Route path="/ultra-admin/user-events" element={<UserEventsPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </StoreProvider>
  );
}

export default App;
